import React from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';
import { DateFormats } from '../../../constants/common';

interface Props {
  value: string;
  format?: string;
}

export const DateCell = ({ value, format = DateFormats.DateTimeShort12Hour }: Props) => {
  return (
    <Typography component="span" variant="body2">
      {moment(value).format(format)}
    </Typography>
  );
};
